import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import { getAppConfiguration } from "appConfig";

const endpoint = "/api/deviceType";

export async function getDeviceTypeList() {
  const appConfiguration = await getAppConfiguration();
  // összes eszköztipus lekérése
  return axiosFetch.get(
    `${endpoint}/getAllDeviceTypes/${appConfiguration.providerId}`
  );
}

export async function getAllDefaultDeviceTypes() {
  return axiosFetch.get(endpoint);
}

export async function getCustomDeviceTypeList(providerId: string) {
  return axiosFetch.get(`${endpoint}/getAllDeviceTypes/${providerId}`);
}

export async function getDeviceTypeById(deviceId: string) {
  return axiosFetch.get(`${endpoint}/${deviceId}`);
}

export async function updateDeviceType(body: FormData) {
  return axiosFetch.post(`${endpoint}/upsert`, body);
}

export async function customName(
  deviceTypeId: string,
  providerId: string,
  body: { customName: string }
) {
  return axiosFetch.post(
    `${endpoint}/${deviceTypeId}/ofProvider/${providerId}`,
    body
  );
}
